import { createSlice } from "@reduxjs/toolkit";
import { VoteHeadResponseDto } from "../../shared/dtos/voteHead/VoteHeadResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const voteHeadSlice = createSlice({
  name: "voteHead",
  initialState: getInitialCrudState<VoteHeadResponseDto>(),
  reducers: {
    ...generateCrudReducers<VoteHeadResponseDto>(),
  },
});

export const voteHeadActions = voteHeadSlice.actions;
export default voteHeadSlice.reducer;
